import { render, staticRenderFns } from "./Sitemap.html?vue&type=template&id=1a98c6a9&scoped=true&"
import script from "./Sitemap.vue?vue&type=script&lang=ts&"
export * from "./Sitemap.vue?vue&type=script&lang=ts&"
import style0 from "./Sitemap.scss?vue&type=style&index=0&id=1a98c6a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a98c6a9",
  null
  
)

export default component.exports